<template>
    <div class="row page">
        <div class="col-md-4 offset-md-4 p-5">
            <router-link :to="{ name: 'ForgotPassword' }" tag="h1" class="mb-5">Wachtwoord Vergeten?</router-link>

            <form @submit.prevent="send">
                <div class="form-group mb-3">
                    <label for="username" hidden>Email</label>
                    <input :class="['form-control', failedLogin ? 'is-invalid' : failedLogin == null ? '' : 'is-valid']" placeholder="Email..." required name="username" id="username" v-model="user.userName" :disabled="isLoading">
                </div>
                <div class="form-group text-right">
                    <loader v-if="isLoading" width="2rem"></loader>
                    <button type="confirm" class="btn btn-half btn-outline-azure btn-lg mb-3" v-else :disabled="isLoading">
                        <span>Versturen</span>
                        <div class="btn-icon">
                            <span>&rarr;</span>
                        </div>
                    </button>
                </div>
                <div class="alert alert-danger" role="alert" v-if="isError">
                    <strong>Oeps!</strong> Wachtwoord reset is mislukt. Probeer nogmaals.
                </div>
                <div class="alert alert-success" role="alert" v-if="isSuccess">
                    <strong>Succes!</strong> Controleer uw email voor de reset-link.
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import Loader from '@/components/Loader';
export default {
    components: {
        'loader': Loader
    },
    data() {
        return {
            user: {
                userName: ''
            },
            isLoading: false,
            isError: false,
            isSuccess: false
        }
    },
    methods: {
        send() {
            this.isLoading = true;
            this.$http.post("api/Auth/ForgotPassword/"+ this.user.userName, { }).then((res) => {
                this.isError = false;
                this.isSuccess = true;
                this.isLoading = false;
            }).catch((res) => {
                this.isError = true;
                this.isLoading = false;
                this.isSuccess = false;
                console.log(res.data);
            });
        }
    }
}
</script>
